import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Grid } from 'semantic-ui-react';
import { OVERLAY_VALUES } from '../constants';

const overlayStyle = {
  height: '100%'
}

const overlayButtonStyle = {
  fontSize: '1600%',
  fontWeight: 'bold',
  padding: '0',
  height: '100%'
};

const Overlay = (props) =>  {
  return (
  <Grid columns={1} padded style={overlayStyle}>
    <Grid.Row stretched>
      <Grid.Column>
        <Link to='/' className='full_height'>
          <Button 
            content={OVERLAY_VALUES[props.match.params.key]}
            style={overlayButtonStyle}
            color='black'
            basic fluid
          />
        </Link>
      </Grid.Column>
    </Grid.Row>
  </Grid>
  )
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.js